import React from "react"
import { useAlgoliaSearchState } from "../../controller/state"
import { BrandSidebarFilter } from "../BrandSidebarFilter"
import { DiscountSidebarFilter } from "../DiscountSidebarFilter"
import PriceSidebarFilter from "../PriceSidebarFilter"
import { ProductCategoryFilter } from "../ProductCategoryFilter"
import { TagSidebarFilter } from "../TagSidebarFilter"

const FilterSidebarItems = () => {
  const { uiFilters } = useAlgoliaSearchState()
  return (
    <>
      <DiscountSidebarFilter />
      <ProductCategoryFilter />
      <BrandSidebarFilter />
      <PriceSidebarFilter />
      {uiFilters?.tags.map((x) => (
        <TagSidebarFilter category={x} key={x.key} />
      ))}
    </>
  )
}

export default FilterSidebarItems
